import { createSelector } from 'reselect';
import { State } from 'flow/types/State';
import { selectExtensionLicenseName } from './ExtensionSelectors';

const selectLicenses = (state: State) =>
    state.licenses.get('extensionLicenses');

export const selectPbxLicenseDescription = (state: State) =>
    state.licenses.getIn(['pbxLicense', 'description']);

export const selectExtensionLicenseDescription = createSelector(
    [selectLicenses, selectExtensionLicenseName],
    (licenses, extensionLicenseName) => {
        if (!licenses) {
            return undefined;
        }

        return licenses.getIn([extensionLicenseName, 'description']);
    },
);
